var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSantaHat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ea4460;}.cls-2{fill:#efece8;}.cls-3{opacity:0.2;}.cls-4,.cls-5{fill:none;stroke:#2e313f;stroke-miterlimit:10;stroke-width:2px;}.cls-4{stroke-linecap:round;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "santas-hat") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Outlines"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.35,25.53c-2.46-5-1.83-9.88-1.55-12.82A5.91,5.91,0,0,1,28,13a6,6,0,0,1-6-6,26.32,26.32,0,0,0-7.63,5.64C7.56,20.14,6.19,30.67,6,33H36A37.13,37.13,0,0,1,31.35,25.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M36,43H6a5,5,0,0,1-5-5H1a5,5,0,0,1,5-5H36a5,5,0,0,1,5,5h0A5,5,0,0,1,36,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M36,40H6a5,5,0,0,1-4.74-3.5A4.92,4.92,0,0,0,6,43H36a4.95,4.95,0,0,0,4.75-6.5A5,5,0,0,1,36,40Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.39,30C6.14,31.38,6,32.43,6,33H36a30.88,30.88,0,0,1-2.15-3Z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 27.96,
    cy: 7,
    r: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M21.93,21.1h0c.08,0,7,0,9.58,4.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M36,43H6a5,5,0,0,1-5-5H1a5,5,0,0,1,5-5H36a5,5,0,0,1,5,5h0A5,5,0,0,1,36,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.39,25.53c-2.46-5-1.84-9.88-1.55-12.82A5.91,5.91,0,0,1,28,13a6,6,0,0,1-6-6,26.36,26.36,0,0,0-7.64,5.64C7.6,20.14,6.23,30.67,6,33H36A37.13,37.13,0,0,1,31.39,25.53Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-5",
    cx: 28,
    cy: 7,
    r: 6
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSantaHat);
export default __webpack_public_path__ + "static/media/santaHat.3bb3d2ab410660d6a314981d41676c77.svg";
export { ForwardRef as ReactComponent };